module.exports = __webpack_public_path__ + "static/img/3bg_1.3f785c7.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/3bg_1.png
// module id = 676
// module chunks = 1